module.exports = __webpack_public_path__ + "static/media/fifteenth_cleo_rogers_memorial_library8.05822fda.png";